import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ProductEquivalence')
export class ProductEquivalence {
  @JsonProperty('ean', String, true) ean: string = undefined;
  @JsonProperty('equivalentCode', String, true) equivalentCode: string = undefined;
  @JsonProperty('equivalenceType', String, true) equivalenceType: string = undefined;
}
